import {NgModule} from '@angular/core';

import {PrimaryLinkComponent} from './primary-link/primary-link.component';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [CommonModule],
  exports: [PrimaryLinkComponent],
  declarations: [PrimaryLinkComponent],
  providers: [],
})
export class LinkModule {
}
